import { useReducer } from 'react';
import { type } from './internacionesTramitesActions';
import { internacionesTramitesReducer } from './internacionesTramitesReducer';
import { InternacionesTramitesContext } from './InternacionesTramitesContext';

const init = () => {
  return {
    anualList: [],
    mensualDate: null,
    mensualList: [],
    anualDate: null,
  };
};

export const InternacionesTramitesProvider = ({ children }) => {
  const [internacionesTramitesState, dispatch] = useReducer(internacionesTramitesReducer, {}, init);

  const setInternacionesTramitesAnualList = (payload) => {
    dispatch({
      type: type.anualList,
      payload: payload.data,
      date: payload.date,
    });
  };

  const setInternacionesTramitesMensualList = (payload) => {
    dispatch({
      type: type.mensualList,
      payload: payload.data,
      date: payload.date,
    });
  };

  return (
    <InternacionesTramitesContext.Provider
      value={{
        ...internacionesTramitesState,
        setInternacionesTramitesAnualList,
        setInternacionesTramitesMensualList,
      }}
    >
      {children}
    </InternacionesTramitesContext.Provider>
  );
};
